import { clearZendeskToken, saveZendeskToken } from '../services/storageZendesk'

const injectScript = (src) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.async = true
    script.src = src
    script.id = 'ze-snippet'
    script.addEventListener('load', resolve)
    script.addEventListener('error', () => reject(new Error('Error loading Zendesk.')))
    script.addEventListener('abort', () => reject(new Error('Zendesk loading aborted.')))
    document.head.appendChild(script)
  })
}

const zendeskAuthenticate = (token) => {
  window.zE(
    'messenger',
    'loginUser',
    function jwtCallback(callback) {
      callback(token)
    },
    function loginCallback(error) {
      if (error) {
        console.error('[Zendesk]', 'failed to login:', error)
        clearZendeskToken()
      } else {
        // Zendesk logged in
      }
    }
  )
}

export const activeZendesk = ({ authenticate }) => {
  injectScript('https://static.zdassets.com/ekr/snippet.js?key=b75089af-1ae8-4068-bed4-2e98a0f7b8ed')
    .then(() => {
      // Zendesk script loaded
      window.zE('messenger', 'hide')

      window.zE('messenger:on', 'close', function () {
        window.zE('messenger', 'hide')
      })
      window.zE('messenger:on', 'open', function () {
        window.zE('messenger', 'show')
      })

      // Zendesk authenticating
      authenticate().then((newToken) => {
        if (newToken) {
          saveZendeskToken(newToken)
          zendeskAuthenticate(newToken)
        } else {
          clearZendeskToken()
        }
      })
    })
    .catch((error) => {
      console.error('[Zendesk]', 'Failed to start:', error)
      clearZendeskToken()
    })
}
